export type AppErrorArgs = {
    status: number;
    type: string;
    title: string;
    detail?: string | unknown;
    instance: string;
    [key: string]: unknown;
};

export const ErrorTypes = {
    INVALID_INPUT: 'https://example.com/probs/invalid-input',
    UNAUTHORIZED_ACCESS: 'https://petsmart.com/probs/unauthorized',
    RESOURCE_NOT_FOUND: 'https://petsmart.com/probs/resource-not-found',
    INTERNAL_SERVER_ERROR: 'https://petsmart.com/probs/internal-server-error',
};

export class AppError extends Error {
    status: number;
    type: string;
    title: string;
    detail: string | unknown;
    instance: string;
    [key: string]: unknown;

    constructor({
        status,
        type,
        title,
        detail,
        instance,
        ...extraFields
    }: AppErrorArgs) {
        super();

        this.status = status;
        this.type = type;
        this.title = title;
        this.detail = detail;
        this.instance = instance;
        Object.assign(this, extraFields);
    }
}
